module.exports = __webpack_public_path__ + "img/audit.8718b702.svg";